import Axios from "../../api/Axios";
const BASE_URL = "BeatFrequencyPlanning/";
export const Endpoint = {
    DownloadTemplate: "DownloadTemplate",
    UploadExcel: "UploadExcel",
};
// /api/BeatFrequencyPlanning/DownloadTemplate
// /api/BeatFrequencyPlanning/UploadExcel
export const createAPIEndpntBeatfreq = () => {
    return { get: (Endpoint) => Axios.get(BASE_URL + Endpoint),
        post: (Endpoint,data)=> Axios.post(BASE_URL+Endpoint,data)
    };
};
